import { TFunction } from "react-i18next";
import { NotClosedOrder, StocktakingApi } from "src/services/Api/Organization/types";
import { UnprocessableEntity } from "go-core/api/exceptions";
import {
	FILTER_SEPARATOR,
	FILTER_VALUE_SEPARATOR,
	NEW_WAY_TO_ENCODING_FILTER_SIGN,
} from "go-list/core/components/Filter/services";
import { OrderNotClosedApiError, OrderNotClosedConfig } from "./types";

export const getErrorOrderNotClosed = (err: unknown): OrderNotClosedApiError | undefined => {
	if (err instanceof UnprocessableEntity) {
		const apiError = err.errors.find((error) => error.message === "order_not_closed_exist");

		return apiError as OrderNotClosedApiError;
	}
};

export const getOrderNotClosedConfig = (
	t: TFunction,
	notClosedOrders?: NotClosedOrder[],
	organizationId?: number | number,
	stocktaking?: StocktakingApi
): OrderNotClosedConfig[] => {
	if (!notClosedOrders) return [];

	return notClosedOrders.map((order) => {
		switch (order) {
			case NotClosedOrder.PURCHASE_ORDER: {
				const params = btoa(
					unescape(
						encodeURIComponent(
							`${NEW_WAY_TO_ENCODING_FILTER_SIGN}${FILTER_SEPARATOR}statuses|e=UNLINKED${FILTER_VALUE_SEPARATOR}OPEN${FILTER_VALUE_SEPARATOR}PARTIALLY_RECEIVED${
								stocktaking
									? `${FILTER_SEPARATOR}stockIds|e=${stocktaking.stock.id}${FILTER_SEPARATOR}purchased_at|lte=${stocktaking.stocktaking_at}`
									: ""
							}`
						)
					)
				);
				return {
					redirectLink: `/${organizationId}/documents/purchases?f=${params}`,
					translation: t("modules.stocktaking.field.order_not_closed_purchases_alert.title"),
					documentType: order,
				};
			}
			case NotClosedOrder.SALES_ORDER: {
				const params = btoa(
					unescape(
						encodeURIComponent(
							`${NEW_WAY_TO_ENCODING_FILTER_SIGN}${FILTER_SEPARATOR}statuses|e=UNLINKED${FILTER_VALUE_SEPARATOR}OPEN${FILTER_VALUE_SEPARATOR}PARTIALLY_SHIPPED${
								stocktaking
									? `${FILTER_SEPARATOR}stockIds|e=${stocktaking.stock.id}${FILTER_SEPARATOR}ordered_at|lte=${stocktaking.stocktaking_at}`
									: ""
							}`
						)
					)
				);

				return {
					redirectLink: `/${organizationId}/documents/sales?f=${params}`,
					translation: t("modules.stocktaking.field.order_not_closed_sales_alert.title"),
					documentType: order,
				};
			}
			case NotClosedOrder.TRANSFER_ORDER: {
				const params = btoa(
					unescape(
						encodeURIComponent(
							`${NEW_WAY_TO_ENCODING_FILTER_SIGN}${FILTER_SEPARATOR}statuses|e=OPEN${
								stocktaking ? `${FILTER_SEPARATOR}transferred_at|lte=${stocktaking.stocktaking_at}` : ""
							}`
						)
					)
				);

				return {
					redirectLink: `/${organizationId}/documents/transfers?f=${params}`,
					translation: t("modules.stocktaking.field.order_not_closed_transfers_alert.title"),
					documentType: order,
				};
			}
			case NotClosedOrder.BUNDLE: {
				const params = btoa(
					unescape(
						encodeURIComponent(
							`${NEW_WAY_TO_ENCODING_FILTER_SIGN}${FILTER_SEPARATOR}statuses|e=OPEN${
								stocktaking ? `${FILTER_SEPARATOR}bundled_at|lte=${stocktaking.stocktaking_at}` : ""
							}`
						)
					)
				);

				return {
					redirectLink: `/${organizationId}/documents/bundles?f=${params}`,
					translation: t("modules.stocktaking.field.bundle_not_closed_transfers_alert.title"),
					documentType: order,
				};
			}
			case NotClosedOrder.STOCK_ADJUSTMENT: {
				const params = btoa(
					unescape(
						encodeURIComponent(
							`${NEW_WAY_TO_ENCODING_FILTER_SIGN}${FILTER_SEPARATOR}status|e=OPEN${
								stocktaking ? `${FILTER_SEPARATOR}date|lte=${stocktaking.stocktaking_at}` : ""
							}`
						)
					)
				);

				return {
					redirectLink: `/${organizationId}/documents/stock_adjustments?f=${params}`,
					translation: t("modules.stocktaking.field.stock_adjustment_not_closed_transfers_alert.title"),
					documentType: order,
				};
			}
			case NotClosedOrder.PURCHASE_CORRECTION: {
				return {
					translation: `${t(
						"modules.stocktaking.field.stock_adjustment_not_closed_corrections_alert.title"
					)}: `,
					documentType: order,
				};
			}
			default:
				return { translation: t("modules.stocktaking.field.order_not_closed_alert.title") };
		}
	});
};
